module.exports = __webpack_public_path__ + "static/assets/49426b0298be4b8176619028760b1332.png";